module.exports = __webpack_public_path__ + "img/1200668794.b6ceaf0e.jpg";